<template>
  <div class="index-container">
    <div class="welcome-box">
      <h2 class="title">欢迎使用 tnbapp</h2>
      <p class="subtitle">请选择您需要访问的 app 入口</p>

      <div class="btn-group">
        <el-button icon="el-icon-film" size="small" class="custom-btn" @click="navTo('/')">VOD(移动端)</el-button>
        <el-button icon="el-icon-film" size="small" class="custom-btn" @click="navTo('/vod')">VOD(PC 端)</el-button>
        <el-button icon="el-icon-notebook-2" size="small" class="custom-btn" @click="navTo('/book')">Book(移动端)</el-button>
        <el-button icon="el-icon-files" size="small" class="custom-btn" @click="navTo('/disk')">Disk(移动端)</el-button>
        <el-button icon="el-icon-edit" size="small" class="custom-btn" @click="navTo('/exam')">Exam(PC 端)</el-button>
        <el-button icon="el-icon-location" size="small" class="custom-btn" @click="navTo('/map')">Map(PC 端)</el-button>
        <el-button icon="el-icon-document" size="small" class="custom-btn" @click="navTo('/blog')">Blog(PC 端)</el-button>
        <el-button icon="el-icon-shopping-bag-1" size="small" class="custom-btn" @click="navTo('/mall')">Mall(PC 端)</el-button>
        <el-button icon="el-icon-cpu" size="small" class="custom-btn" @click="navTo('/ai')">AI(PC 端)</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  methods: {
    navTo(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped lang="scss">
.index-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f4f5f7;
  padding: 20px;
  box-sizing: border-box;

  .welcome-box {
    text-align: center;
    max-width: 650px;
    width: 100%;

    .title {
      font-size: 24px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 8px;
    }

    .subtitle {
      font-size: 14px;
      color: #909399;
      margin-bottom: 24px;
    }

    .btn-group {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
      gap: 14px;
      padding: 30px;
      background: #ffffff;
      border-radius: 12px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

      .custom-btn {
        width: 100%;
        margin: 0 !important;
        height: 42px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 8px;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
        }
      }
    }
  }
}
</style>
